import { render, staticRenderFns } from "./CmgOrderConfirmationOrderSummary.vue?vue&type=template&id=4151be00&scoped=true&lang=pug"
import script from "./cmg-order-confirmation-order-summary.ts?vue&type=script&lang=ts&external"
export * from "./cmg-order-confirmation-order-summary.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOrderConfirmationOrderSummary.vue?vue&type=style&index=0&id=4151be00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4151be00",
  null
  
)

export default component.exports